(() => {
  const stampKey = 'honeyvera-welcome-dismissed';
  const signupKey = 'honeyvera-welcome-subscribed';
  const read = (key) => { try { return localStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch { /* The dialog still works without storage. */ } };
  function boot() {
    document.querySelectorAll('[data-hv-welcome]').forEach((dialog) => {
      if (dialog.dataset.initialized === 'true' || typeof dialog.showModal !== 'function') return;
      dialog.dataset.initialized = 'true';
      const state = dialog.querySelector('[data-hv-welcome-state]');
      const successful = state?.dataset.success === 'true';
      const errors = state?.dataset.errors === 'true';
      const open = () => { if (!dialog.open) dialog.showModal(); };
      const dismiss = () => { write(stampKey, String(Date.now())); dialog.close(); };
      dialog.querySelectorAll('[data-hv-welcome-close]').forEach((button) => button.addEventListener('click', dismiss));
      document.querySelectorAll('[data-hv-welcome-open]').forEach((button) => {
        if (button.dataset.hvWelcomeOpen === dialog.id) button.addEventListener('click', open);
      });
      dialog.addEventListener('cancel', () => write(stampKey, String(Date.now())));
      dialog.addEventListener('click', (event) => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dismiss();
      });
      if (successful) write(signupKey, 'true');
      const requested = new URLSearchParams(window.location.search).get('honeyvera_offer') === '1';
      if (successful || errors || requested) { open(); return; }
      const recentlyDismissed = Date.now() - Number(read(stampKey)) < 7 * 86400000;
      const excludedPage = ['cart', 'policy', 'customers/login', 'customers/account'].includes(dialog.dataset.pageType);
      if (!read(signupKey) && !recentlyDismissed && !excludedPage) {
        setTimeout(() => { if (document.visibilityState === 'visible' && !document.querySelector('dialog[open]')) open(); }, Number(dialog.dataset.delay) * 1000);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
